import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams } from "react-router-dom";
import { get } from 'lodash';

import CustomerForm from '../Management/Customer/customerForm';
import CustomModal from '../../components/CustomModal';
import { getReturnNote, getCustomersByName, updateSearchedName, clearCustomerList, selectCustomer, changeReturnNoteObj, saveReturnNote, updateValidationObject, getReturnNoteById, toggleShowCustomerModal, checkSerialNo, updateComment, deleteComment } from '../../store/actions/returnNote';
import { IReturnNote, IMasterData, MasterDataFields, IReturnNoteMasterData, ReturnNoteType } from '../../shared/models/returnNoteModels';

// inputs
import FormCard from '../../components/FormControls/Card';
import FormCheckBox from '../../components/FormControls/CheckBox';
import FormTextArea from '../../components/FormControls/TextArea';
import AutoSuggest from '../../components/AutoSuggest';

// Types
import { ICustomer } from '../../shared/models/adminModels';
import { getAddress, getYearList, convertUTCDateToLocalDate } from '../../services/utilService';
import { MESSAGES } from '../../services/constants';
import { getCustomer } from '../../store/actions/management';
import { IModulesPermissions } from '../../shared/models/rolesPermissionModel';
import BackButton from '../../components/BackButton';
import { Modal, Button } from 'react-bootstrap';

interface IProps {
  masterData: IReturnNoteMasterData;
  modelOtherId: string;
  equipmentOther1Id: string
  equipmentOther2Id: string
  getReturnNote: Function,
  returnNote: IReturnNote,
  getCustomersByName: Function,
  customerList: ICustomer[],
  searchedName: string,
  updateSearchedName: Function,
  clearCustomerList: Function,
  isLoading: boolean,
  selectCustomer: Function,
  selectedCustomer: ICustomer,
  changeReturnNoteObj: Function,
  saveReturnNote: Function,
  validations: any,
  updateValidationObject: Function,
  getReturnNoteById: Function,
  getCustomer: Function,
  checkSerialNo: Function,
  isEditMode: boolean,
  permission: IModulesPermissions,
  toggleShowCustomerModal: Function,
  showModal: boolean,
  updateComment: Function,
  deleteComment: Function,
}

const ReturnNote = (props: IProps) => {
  const history = useHistory();
  const { pt, col }: any = useLocation().state || {};
  const {
    masterData,
    modelOtherId,
    equipmentOther1Id,
    equipmentOther2Id,
    getReturnNote,
    returnNote,
    getCustomersByName,
    customerList = [],
    searchedName = '',
    updateSearchedName,
    clearCustomerList,
    isLoading,
    selectCustomer,
    selectedCustomer,
    changeReturnNoteObj,
    saveReturnNote,
    validations,
    updateValidationObject,
    getReturnNoteById,
    getCustomer,
    isEditMode = false,
    permission,
    toggleShowCustomerModal,
    showModal = false,
    checkSerialNo,
    updateComment,
    deleteComment,
  } = props;

  const {
    returnNo,
    modelOtherValue,
    equipmentOther1Value,
    equipmentOther2Value,
    serialNo,
    year,
    model,
    gases,
    action,
    reason,
    selectedEquipments,
    faultDescription,
    reasonForReturn,
    notes,
    raisedByUserId,
    customerId,
    comments,
    raisedBy,
    commentsHistories = [],
    productTypeID = pt,
    raisedByDate,
    isLocked,
    message,
    voltage,
  } = returnNote;

  const {
    listOfModels = [],
    listOfReasons = [],
    listOfActions = [],
    listOfGases = [],
    listOfEquipments = []
  } = masterData || {};

  // ref
  const autoCompleteDiv = useRef(null);
  const modelDiv = useRef(null);
  const gasesDiv = useRef(null);
  const reasonDiv = useRef(null);
  const serialNoDiv = useRef(null);
  const actionDiv = useRef(null);
  const equipmentDiv = useRef(null);

  const [editCommentId, setEditCommentId] = useState('');
  const [editedComment, setEditedComment] = useState('');
  const [smShow, setSmShow] = useState(false);
  const [deleteCommentId, setDeleteCommentId] = useState('');

  // get params
  const { id: returnNoteId } = useParams();
  const haveCreatePermission = get(permission.productReturnDashboard, 'create', false);
  const haveEditPermission = get(permission.productReturnDashboard, 'edit', false);
  const haveViewPermission = get(permission.productReturnDashboard, 'view', false);
  const haveCreateCustomerPermission = get(permission.manageCustomer, 'create', false);

  const getReturnNoteByIdFn = async () => {
    try {
      const customerId = await getReturnNoteById(returnNoteId);
      const customer = await getCustomer(customerId);
      selectCustomer(customer);
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (returnNoteId && (haveEditPermission || haveViewPermission)) {
      getReturnNoteByIdFn();
    } else if (haveCreatePermission && pt && col) {
      getReturnNote(pt, col);
    } else {
      // no permission for create or edit
      return history.goBack();
    }
    resetValidations();
  }, []);

  const getIndexOfItem = (id: string, fieldName: string) => {
    // find the id is exist on array of string if yes then select else remove
    const index = returnNote[fieldName].findIndex((item: any) => item === id);
    return index;
  }

  const handleSelection = (event: any, id: string) => {
    const fieldName: string = event.target.name;
    const index = getIndexOfItem(id, fieldName);

    if (fieldName === MasterDataFields.action) {
      index > -1 ?
        returnNote[fieldName].splice(index, 1) :
        returnNote[fieldName].push(id);
    } else {
      index > -1 ? returnNote[fieldName].splice(index, 1) : returnNote[fieldName] = [id];
    }

    if (fieldName === MasterDataFields.model && id === modelOtherId) {
      validations.modelOtherValue.required = true;
    } else if (fieldName === MasterDataFields.model && id !== modelOtherId) {
      validations.modelOtherValue.required = false;
      validations.modelOtherValue.errorMessage.required = null;
    }
    if (fieldName === MasterDataFields.reason) {
      returnNote.faultDescription = '';
      returnNote.reasonForReturn = '';
    }
    // check field is valid
    checkFieldValidation(fieldName);
    return changeReturnNoteObj({ ...returnNote });
  }

  const updateValidationForEquipmentOther1 = (isSelected = false) => {
    if (isSelected) {
      validations.equipmentOther1Value.required = true;
      validations.equipmentOther1Value.errorMessage.required = MESSAGES.requiredField('other1');
    } else {
      returnNote.equipmentOther1Value = '';
      validations.equipmentOther1Value.required = false;
      validations.equipmentOther1Value.errorMessage.required = null;
    }
  }

  const updateValidationForEquipmentOther2 = (isSelected = false) => {
    if (isSelected) {
      validations.equipmentOther2Value.required = true;
      validations.equipmentOther2Value.errorMessage.required = MESSAGES.requiredField('other2');
    } else {
      returnNote.equipmentOther2Value = '';
      validations.equipmentOther2Value.required = false;
      validations.equipmentOther2Value.errorMessage.required = null;
    }
  }

  const getUpdatedValdiationObject = () => {
    if (checkEqupmentSelected(equipmentOther1Id as any)) {
      updateValidationForEquipmentOther1(true)
    } else {
      updateValidationForEquipmentOther1(false)
    }
    if (checkEqupmentSelected(equipmentOther2Id as any)) {
      updateValidationForEquipmentOther2(true)
    } else {
      updateValidationForEquipmentOther2(false)
    }
  }

  const addEquipment = (event: any, id: any) => {
    const isSelected = checkEqupmentSelected(id);
    if (isSelected) {
      delete selectedEquipments[id];
    } else {
      selectedEquipments[id] = 0
    }
    returnNote.selectedEquipments = selectedEquipments;
    if (id === equipmentOther1Id) {
      updateValidationForEquipmentOther1(!isSelected);
      checkFieldValidation('equipmentOther1Value');
    } else if (id === equipmentOther2Id) {
      updateValidationForEquipmentOther2(!isSelected);
      checkFieldValidation('equipmentOther2Value');
    } else {
      checkFieldValidation('selectedEquipments');
    }
    changeReturnNoteObj({ ...returnNote });
  }

  const setEquipmentQuantity = (event: any, id: any) => {
    selectedEquipments[id] = Number(event.target.value) || 0;
    returnNote.selectedEquipments = selectedEquipments;
    checkFieldValidation('selectedEquipments');
    return changeReturnNoteObj({ ...returnNote });
  }

  const getEquipmentValue = (id: any) => selectedEquipments[id]
    ? selectedEquipments[id]
    : 0;

  const handleChange = (e: any) => {
    const fieldName: string = e.target.name;

    returnNote[fieldName] = e.target.value;

    if (fieldName === 'faultDescription' || fieldName === 'reasonForReturn') {
      fieldName !== 'faultDescription'
        ? returnNote['faultDescription'] = '' : returnNote['reasonForReturn'] = '';
    }

    if (fieldName === 'voltage') {
      checkFieldValidation('voltage');
    }

    if (fieldName === 'equipmentOther1Value') {
      // change the value for this id in equipment object
      returnNote.selectedEquipments[equipmentOther1Id] = e.target.value
      updateValidationForEquipmentOther1(true)
      checkFieldValidation('equipmentOther1Value');
    }

    if (fieldName === 'equipmentOther2Value') {
      // change the value for this id in equipment object
      returnNote.selectedEquipments[equipmentOther2Id] = e.target.value
      updateValidationForEquipmentOther2(true)
      checkFieldValidation('equipmentOther2Value');
    }

    return changeReturnNoteObj({ ...returnNote });
  }

  const checkEqupmentSelected = (id: number) => selectedEquipments[id] || selectedEquipments[id] === 0 ? true : false;

  const cancelReturnNote = () => {
    // reset customer
    updateSearchedName('');
    selectCustomer(null);

    return history.goBack();
  }

  const checkFieldValidation = async (fieldName: string, formSubmit = false) => {
    let formIsValid = true;
    // for required
    if (validations[fieldName].required) {
      let isValid = true;
      let errorMessage = '';

      if (validations[fieldName].isArray) {
        // @ts-ignore
        isValid = !returnNote[fieldName].length ? false : true;
      } else if (validations[fieldName].isObject) {
        if (selectedCustomer) {
          // @ts-ignore
          isValid = !selectedCustomer[validations[fieldName].checkKeyName] ? false : true;
        } else {
          isValid = false;
        }
      } else {
        // @ts-ignore
        isValid = !returnNote[fieldName] ? false : true;
      }
      // validations[fieldName].isValid = isValid;
      if (!isValid) {
        // set error message;
        if (validations[fieldName].type === 'select') {
          errorMessage = haveCreateCustomerPermission ? MESSAGES.customerAutoComplete : MESSAGES.selectCustomer;
        } else if (validations[fieldName].type === 'radio') {
          const fieldNm = fieldName === 'gases' ? 'gas' : fieldName;
          errorMessage = MESSAGES.radioField(fieldNm);
        } else if (validations[fieldName].type === 'text') {
          errorMessage = MESSAGES.requiredField(validations[fieldName].label || fieldName);
          if (fieldName === 'serialNo') {
            errorMessage = MESSAGES.serialNoRequired;
          } else if (fieldName === 'modelOtherValue') {
            errorMessage = MESSAGES.requiredValue;
          }
        }
        formIsValid = false;
      } else {
        errorMessage = ''
      }
      validations[fieldName].errorMessage.required = errorMessage;
    }

    // for min and max value if exist
    if (validations[fieldName].valueType === 'number') {
      let isMinMaxErrorSet = false;
      const min = validations[fieldName].min || 0;
      const max = validations[fieldName].max;

      Object.keys(selectedEquipments).map((key: string) => {
        if (
          key != '1' && key != '2' && key != '13' && key != '14' &&
          (selectedEquipments[key] < min || selectedEquipments[key] > max)
        ) {
          isMinMaxErrorSet = true;
        }
      });
      if (isMinMaxErrorSet) {
        formIsValid = false
        validations[fieldName].errorMessage.min = MESSAGES.invalidEquipmentQuantity(min, max);
      } else {
        validations[fieldName].errorMessage.min = '';
      }
    }

    // if (formSubmit && (fieldName === 'serialNo' && serialNo)) {
    //   // const returnNoteIdParam = isEditMode ? returnNoteId : 0;
    //   // await checkSerialNo(serialNo, returnNoteIdParam);
    //   formIsValid = validations.serialNo.isValid;
    // }

    if (fieldName === 'serialNo') {
      if (!validations.serialNo.isValid) {
        formIsValid = false;
      }
    }

    // for regex
    if (validations[fieldName] && validations[fieldName].regex && returnNote[fieldName] && returnNote[fieldName] != 0) {
      // check entered value is number and have up to 2 decimal
      let voltageValueIsValid = validations[fieldName].regex.test(returnNote[fieldName]);
      if (!voltageValueIsValid && returnNote[fieldName] && returnNote[fieldName] != 0) {
        formIsValid = false;
        validations[fieldName].errorMessage.pattern = MESSAGES.voltagePattern;
      } else {
        validations[fieldName].errorMessage.pattern = '';
      }
    } else {
      validations[fieldName].errorMessage.pattern = '';
    }

    validations[fieldName].isValid = formIsValid;
    updateValidationObject({ ...validations });
    return formIsValid;
  }

  const handleSubmit = async () => {
    returnNote.customerId = selectedCustomer ? selectedCustomer.id : '';
    let formIsValid = true;
    let isScrolled = false;
    await checkSerialNoValidation();
    getUpdatedValdiationObject();
    Object.keys(validations).map((fieldName: string) => {
      checkFieldValidation(fieldName, true);
      if (!validations[fieldName].isValid) {
        formIsValid = false;
        if (!isScrolled) {
          if (fieldName === 'selectedCustomer') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: autoCompleteDiv.current.offsetTop - 70 })
          } else if (fieldName === 'model') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: modelDiv.current.offsetTop - 70 })
          } else if (fieldName === 'modelOtherValue') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: modelDiv.current.offsetTop - 85 })
          } else if (fieldName === 'serialNo') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: serialNoDiv.current.offsetTop - 85 })
          } else if (fieldName === 'voltage') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: serialNoDiv.current.offsetTop - 85 })
          } else if (fieldName === 'action') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: actionDiv.current.offsetTop - 85 })
          } else if (fieldName === 'gases') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: gasesDiv.current.offsetTop - 85 })
          } else if (fieldName === 'reason') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: reasonDiv.current.offsetTop - 85 })
          } else if (fieldName === 'selectedEquipments' || fieldName === 'equipmentOther1Value' || fieldName === 'equipmentOther2Value') {
            // @ts-ignore
            window.scrollTo({ behavior: 'smooth', top: equipmentDiv.current.offsetTop - 135 })
          }
          isScrolled = true;
        }
      }
    });

    if (returnNote.voltage == '') {
      returnNote.voltage = null as any;
    } else if (!isNaN(returnNote.voltage as any)) {
      returnNote.voltage = parseFloat(returnNote.voltage as any);
    }

    if (formIsValid) {
      saveReturnNote({ ...returnNote })
        .then(() => {
          history.goBack();
        })
        .catch((e: any) => {
          console.error(e);
        });
    } else {
      updateValidationObject({ ...validations });
    }
  }

  const getErrorMessage = (validations: any, fieldName: string) => {
    return !validations[fieldName].isValid
      ? <div className='text-danger float-right'> {
        get(validations, `${fieldName}.errorMessage.required`) ||
        get(validations, `${fieldName}.errorMessage.select`) ||
        get(validations, `${fieldName}.errorMessage.min`) ||
        get(validations, `${fieldName}.errorMessage.max`) ||
        get(validations, `${fieldName}.errorMessage.serialNoExist`) ||
        get(validations, `${fieldName}.errorMessage.maxLength`) ||
        get(validations, `${fieldName}.errorMessage.pattern`)
      } </div>
      : null
  }

  const resetValidations = () => {
    Object.keys(validations).map((fieldName: string) => {
      checkFieldValidation(fieldName);
      validations[fieldName].errorMessage = {};

      updateValidationObject({ ...validations });
    });
  }

  const getPageTitle = () => {
    if (ReturnNoteType.GasAnalyser === productTypeID) {
      return 'Analyser';
    } else if (ReturnNoteType.GasMixer === productTypeID) {
      return 'Mixer';
    } else if (ReturnNoteType.LeakDetection === productTypeID) {
      return 'Leak Detection';
    } else {
      return 'Loading...'
    }
  }

  const handleShowCustomModal = () => {
    toggleShowCustomerModal(!showModal);
  }

  const handleOnChangeInput = (e: any, fieldName: 'year') => {
    returnNote[fieldName] = e.target.value;

    return changeReturnNoteObj({ ...returnNote });
  }

  const checkSerialNoValidation = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (serialNo && serialNo <= 999999999) {
          const returnNoteIdParam = isEditMode ? returnNoteId : 0;
          const response = await checkSerialNo((serialNo), returnNoteIdParam);
          if (response.data) {
            validations.serialNo.isValid = !response.data;
            validations.serialNo.errorMessage.serialNoExist = response.data ? response.message : '';

          } else {
            validations.serialNo.isValid = true;
            validations.serialNo.errorMessage.serialNoExist = '';
            validations.serialNo.errorMessage.maxLength = '';
          }
        } else if (serialNo > 999999999) {
          validations.serialNo.isValid = false;
          validations.serialNo.errorMessage.maxLength = MESSAGES.serialNoMaxLength;
        }

        updateValidationObject({ ...validations });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  const handleOnChangeSerialNo = async (e: any, fieldName: 'serialNo') => {

    const serialNoValue = e.target.value;
    if (!(/^[0-9]*$/).test(serialNoValue)) {
      return;
    }
    returnNote.serialNo = e.target.value;
    // Validate Serial No.
    checkFieldValidation('serialNo');
    // await checkSerialNoValidation();
    // validation for serial number 
    if (serialNoValue) {
      validations[fieldName].isValid = false;
      validations[fieldName].errorMessage.serialNoExist = null;
      if (serialNoValue > 999999999) {
        validations[fieldName].errorMessage.maxLength = MESSAGES.serialNoMaxLength;
      }
    } else {
      validations[fieldName].isValid = true;
      validations[fieldName].errorMessage.maxLength = null;
    }
    updateValidationObject({ ...validations });
    return changeReturnNoteObj({ ...returnNote });
  }

  // const checkSerialNoExistOrNot = async (e: any) => {
  //   e.preventDefault();
  //   const serialNoValue = e.target.value;
  //   if (serialNoValue) {
  //     const returnNoteIdParam = isEditMode ? returnNoteId : 0;
  //     checkSerialNo(serialNoValue, returnNoteIdParam);
  //   }
  // }

  const handleSaveComment = async () => {
    try {
      await updateComment({
        id: editCommentId,
        comments: editedComment,
      })

      setEditCommentId('');
    } catch (e) {
      console.error('not updated')
    }
  }

  const deleteCommentHandler = async (id = deleteCommentId) => {
    setSmShow(false)
    try {
      await deleteComment({
        id
      })
      setEditCommentId('');
    } catch (e) {
      console.error('not deleted')
    }
  }

  const handleDeleteComment = (id: any) => {
    setDeleteCommentId(id);
    setSmShow(true);
  }

  return (<div className='container-fluid width-control'>
    <div className='page-header'>
      <h1>{getPageTitle()}</h1>
      <BackButton />
      <div className="text-danger mt-3">
        {isLocked && message}
      </div>
    </div>
    <div className='page-content product-return'>
      {!isEditMode && haveCreatePermission && <CustomModal
        toggleModal={handleShowCustomModal} show={showModal}
      >
        <CustomerForm isOpenFromModal={true} /></CustomModal>
      }
      <div className='row' ref={autoCompleteDiv}>
        <div className='col-xl-8'>
          <FormCard withBottomBlue appendClass={'d-flex'}>
            <div className='row w-100'>
              <div className='cus-name col-md-3'>
                {getErrorMessage(validations, 'selectedCustomer')}
                <h3>
                  <span>Customer Name</span>
                  {!isEditMode && haveCreatePermission ? <AutoSuggest
                    getData={getCustomersByName}
                    clearData={clearCustomerList}
                    updateValue={updateSearchedName}
                    data={customerList}
                    value={searchedName}
                    isLoading={isLoading}
                    select={selectCustomer}
                    selected={selectedCustomer}
                    validationFunction={checkFieldValidation}
                    fieldName='selectedCustomer'
                    showCustomModal={handleShowCustomModal}
                    createPermission={haveCreateCustomerPermission}
                  /> : get(selectedCustomer, 'customerName', '-')}
                </h3>
              </div>
              <div className='col-md-1 d-flex justify-content-center'>
                <span className='divider' />
              </div>
              <div className='cus-add col-md-8'>
                <h3><span>Customer Address</span>
                  {selectedCustomer ? getAddress(selectedCustomer) : '-'}
                </h3>
              </div>
            </div>
          </FormCard>
        </div>
        <div className='col-xl-4'>
          <FormCard withBottomBlue>
            <h3>
              <span>Returns Note No.</span>
              {returnNo}
            </h3>
          </FormCard>
        </div>
      </div>

      <div className='row' ref={modelDiv}>
        <div className='col-xl-8'>
          <FormCard>
            {getErrorMessage(validations, MasterDataFields.model)}
            {getErrorMessage(validations, 'modelOtherValue')}
            <h3 className='mb-3'>Model</h3>
            <div className='row'>
              {
                listOfModels.map(({ name, id }: IMasterData, index) => {
                  return <div className='col-xl-4' key={id}>
                    <FormCheckBox
                      name={MasterDataFields.model}
                      labelName={name}
                      id={id}
                      checked={getIndexOfItem(id, MasterDataFields.model) > -1 ? true : false}
                      onChange={handleSelection}
                      disabled={!haveCreatePermission && !haveEditPermission}
                    />
                  </div>
                })
              }
              {
                getIndexOfItem(modelOtherId, MasterDataFields.model) > -1 &&
                <div className="col-xl-4">
                  <div className="witt-check modal-othger-inp">
                    <input type="text" className="form-control" name="modelOtherValue"
                      value={modelOtherValue || ''}
                      onChange={handleChange}
                      placeholder={"Other Model"}
                    />
                  </div>
                </div>
              }
            </div>
          </FormCard>
        </div>
        <div className='col-xl-4' ref={gasesDiv}>
          {listOfGases.length > 0 && <FormCard>
            {getErrorMessage(validations, 'gases')}
            <h3 className='mb-3'>Gases</h3>
            <div className='row'>
              {
                listOfGases.map(({ name, id }: IMasterData) => {
                  return <div className='col-xl-6' key={id}>
                    <FormCheckBox
                      name={MasterDataFields.gases}
                      labelName={name}
                      id={id}
                      checked={getIndexOfItem(id, MasterDataFields.gases) > -1 ? true : false}
                      onChange={handleSelection}
                      disabled={!haveCreatePermission && !haveEditPermission}
                    />
                  </div>
                })
              }
            </div>
          </FormCard>}
        </div>
      </div>
      <div ref={serialNoDiv}>
        <FormCard >
          {getErrorMessage(validations, 'serialNo')}
          <div className='row w-100' >

            <div className='cus-name col-md-2'>
              <h3>
                <span>Serial No.</span>
                {/* {serialNo} */}
                {/* onKeyPress={(e) => handleSerialNoOnKeyPress(e)} */}
                <input maxLength={9} type="text" className='form-control' value={serialNo} onChange={(e: any) => handleOnChangeSerialNo(e, 'serialNo')} onPointerLeave={checkSerialNoValidation} onBlur={checkSerialNoValidation} />
              </h3>
            </div>
            <div className='col-md-1 d-flex justify-content-center'>
              <span className='divider' />
            </div>
            <div className='cus-add col-md-3'>
              <h3><span>Year</span></h3>
              <select className='form-control' value={year || ''} disabled={!haveCreatePermission && !haveEditPermission}
                onChange={(e: any) => handleOnChangeInput(e, 'year')}>
                <option value={0}>{'Select'}</option>
                {getYearList().map(singleYear => {
                  return <option key={singleYear} value={singleYear}>{singleYear}</option>
                })}
              </select>
            </div>
            {productTypeID !== ReturnNoteType.GasAnalyser && <>
              <div className='col-md-1 d-flex justify-content-center'>
                <span className='divider' />
              </div>
              <div className='cus-name col-md-2'>
                <h3>
                  <span>Voltage</span>
                  <input
                    name='voltage'
                    type="number"
                    className='form-control'
                    value={voltage || ''}
                    onChange={handleChange} />
                </h3>
                {getErrorMessage(validations, 'voltage')}
              </div>
            </>}
          </div>
        </FormCard>

      </div>
      <div className='row' ref={reasonDiv}>
        <div className='col-xl-8'>
          <FormCard>
            {getErrorMessage(validations, MasterDataFields.reason)}
            <h3 className='mb-3'>Reason For Return</h3>
            <div className='row'>
              {
                listOfReasons.map(({ name, id }: IMasterData, index) => {
                  return <div className='col-xl-6' key={id}>
                    <FormCheckBox
                      name={MasterDataFields.reason}
                      labelName={name}
                      id={id}
                      checked={getIndexOfItem(id, MasterDataFields.reason) > -1 ? true : false}
                      onChange={handleSelection}
                      disabled={!haveCreatePermission && !haveEditPermission}
                    />
                    <FormTextArea
                      name={!index ? 'faultDescription' : 'reasonForReturn'}
                      onChange={handleChange}
                      value={!index ? faultDescription || '' : reasonForReturn || ''}
                      disabled={
                        (getIndexOfItem(id, MasterDataFields.reason) > -1 ? false : true)
                        || (!haveCreatePermission && !haveEditPermission)
                      }
                      placeholder={`Enter ${index ? 'other' : 'fault'} description....`}
                    />
                  </div>
                })
              }
            </div>
          </FormCard>
        </div>
        <div className='col-xl-4' ref={actionDiv}>
          <FormCard>
            {getErrorMessage(validations, MasterDataFields.action)}
            <h3 className='mb-3'>Action To Be Taken</h3>
            <div className='row'>
              {
                listOfActions.map(({ name, id }: IMasterData) => {
                  return <FormCheckBox
                    name={MasterDataFields.action}
                    key={id}
                    appendClass='w-100'
                    labelName={name}
                    id={id}
                    checked={getIndexOfItem(id, MasterDataFields.action) > -1 ? true : false}
                    onChange={handleSelection}
                    disabled={!haveCreatePermission && !haveEditPermission}
                  />
                })
              }
            </div>
          </FormCard>
        </div>
      </div>
      {productTypeID === ReturnNoteType.GasAnalyser && <FormCard>
        <div ref={equipmentDiv}>
          {getErrorMessage(validations, 'selectedEquipments')}
          <br />
          {getErrorMessage(validations, 'equipmentOther1Value')}
          <br />
          {getErrorMessage(validations, 'equipmentOther2Value')}
        </div>
        <h3 className='mb-3'>Equipment Returned</h3>
        <div className='row'>
          {
            listOfEquipments.map(({ name, id }: IMasterData) => {
              return <div className='col-xl-4' key={id}>
                <FormCheckBox
                  name='selectedEquipments'
                  id={id}
                  checked={checkEqupmentSelected(id as any)}
                  labelName={name}
                  onChange={addEquipment}
                  withInput={equipmentOther1Id !== id && equipmentOther2Id !== id}
                  setEquipmentQuantity={setEquipmentQuantity}
                  textInputValue={getEquipmentValue(id)}
                  disabled={!haveCreatePermission && !haveEditPermission}
                />
              </div>
            })
          }
        </div>
        <div className='row'>
          {
            checkEqupmentSelected(equipmentOther1Id as any) &&
            <div className="col-xl-4">
              <div className="witt-check modal-other-inp">
                <input type="text" className="form-control" name="equipmentOther1Value"
                  value={equipmentOther1Value || ''}
                  onChange={handleChange}
                  placeholder={"Equipment Other1"}
                />
              </div>
            </div>
          }
          {
            checkEqupmentSelected(equipmentOther2Id as any) &&
            <div className="col-xl-4">
              <div className="witt-check modal-other-inp">
                <input type="text" className="form-control" name="equipmentOther2Value"
                  value={equipmentOther2Value || ''}
                  onChange={handleChange}
                  placeholder={"Equipment Other2"}
                />
              </div>
            </div>
          }
        </div>
      </FormCard>}
      <FormCard>
        <h3 className='mb-3'>Add a comment</h3>
        <div className='row'>
          <div className='col-xl-12'>
            <FormTextArea
              name='comments'
              onChange={handleChange}
              value={comments || ''}
              placeholder=''
              disabled={!haveCreatePermission && !haveEditPermission}
            />
            <div className="text-right">
              {/* <button className="btn btn-primary mt-3" >ADD</button> */}
            </div>
          </div>
        </div>
      </FormCard>
      {isEditMode && commentsHistories.length > 0 && <FormCard>
        <h3 className='mb-3'>Comment History</h3>
        <div className='row'>
          <div className='col-xl-12'>
            <ul className="comment-list">
              {commentsHistories.map((comment: any) => {
                return <li key={comment.id}>
                  <div className="comment-top">
                    <h3>{comment.updatedBy}</h3>
                    <span className="time"> {convertUTCDateToLocalDate(comment.updatedDate)} <i className="fa fa-clock"></i></span>
                  </div>
                  {editCommentId !== comment.id && <p className="descreption">
                    {comment.comments}
                  </p>}
                  {editCommentId === comment.id && <textarea style={{ minHeight: '150px' }} className="form-control mt-2" value={editedComment} onChange={(e) => setEditedComment(e.target.value)}></textarea>}
                  <div className="comment-action mt-2 d-flex justify-content-end">
                    {editCommentId === comment.id && <button className="btn btn-primary mr-3 h-100 px-3 py-2" onClick={handleSaveComment}> Save </button>}
                    {editCommentId !== comment.id && <button className="btn btn-primary mr-3 h-100 px-3 py-2" onClick={() => { setEditCommentId(comment.id); setEditedComment(comment.comments) }}> Edit </button>}
                    {editCommentId !== comment.id && <button className="btn btn-danger h-100 px-3 py-2" onClick={() => handleDeleteComment(comment.id)}> Delete </button>}
                    {editCommentId === comment.id && <button className="btn btn-danger h-100 px-3 py-2" onClick={() => setEditCommentId('')}> Cancel </button>}
                  </div>
                </li>
              })}
            </ul>
          </div>
        </div>
      </FormCard>}
      <FormCard>
        <div className='row w-100'>
          <div className='cus-name col-md-2'>
            <h3>
              <span>Raised By</span>
              {raisedBy}
            </h3>
          </div>
          <div className='col-md-1 d-flex justify-content-center'>
            <span className='divider' />
          </div>
          <div className='cus-add col-md-9'>
            <h3><span>Date Of Request</span>{raisedByDate ? convertUTCDateToLocalDate(raisedByDate, 'DD MMM YYYY') : ''}</h3>
          </div>
        </div>
      </FormCard>
      {(haveEditPermission || haveCreatePermission) && <div className='actions text-right'>
        <button className='btn btn-secondary mr-3' disabled={isLoading} onClick={cancelReturnNote}>Cancel</button>
        <button className='btn btn-primary' disabled={isLoading || isLocked} onClick={handleSubmit}>Save</button>
      </div>}
    </div>
    <Modal
      size="sm"
      show={smShow}
      onHide={() => setSmShow(false)}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-sm">
          Are you sure?
      </Modal.Title>
      </Modal.Header>
      {/* <Modal.Body></Modal.Body> */}
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setSmShow(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => deleteCommentHandler()}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  </div >)
}

const mapStateToProps = ({ common, returnNote, managementReducer, auth }: any) => ({
  isLoading: common.isLoading,
  masterData: returnNote.masterData,
  modelOtherId: returnNote.modelOtherId,
  equipmentOther1Id: returnNote.equipmentOther1Id,
  equipmentOther2Id: returnNote.equipmentOther2Id,
  returnNote: returnNote.returnNote,
  customerList: returnNote.customerList,
  searchedName: returnNote.searchedName,
  selectedCustomer: returnNote.selectedCustomer,
  validations: returnNote.validations,
  customer: managementReducer.customer,
  isEditMode: returnNote.isEditMode,
  permission: auth.user.permission,
  showModal: returnNote.showModal,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    getReturnNote: (productTypeID: number, col: number) => dispatch(getReturnNote(productTypeID, col)),
    getCustomersByName: (searchName: string) => dispatch(getCustomersByName(searchName)),
    updateSearchedName: (searchName: string) => dispatch(updateSearchedName(searchName)),
    clearCustomerList: () => dispatch(clearCustomerList()),
    selectCustomer: (customer: ICustomer) => dispatch(selectCustomer(customer)),
    changeReturnNoteObj: (returnNote: IReturnNote) => dispatch(changeReturnNoteObj(returnNote)),
    saveReturnNote: (returnNote: IReturnNote) => dispatch(saveReturnNote(returnNote)),
    updateValidationObject: (validationObject: any) => dispatch(updateValidationObject(validationObject)),
    getReturnNoteById: (id: string) => dispatch(getReturnNoteById(id)),
    getCustomer: (id: string) => dispatch(getCustomer(id)),
    checkSerialNo: (serialNo: number, returnNoteId: number) => dispatch(checkSerialNo(serialNo, returnNoteId)),
    toggleShowCustomerModal: (value: boolean) => dispatch(toggleShowCustomerModal(value)),
    updateComment: (data: any) => dispatch(updateComment(data)),
    deleteComment: (data: any) => dispatch(deleteComment(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnNote)